/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { AccessType } from "@quintype/components";
import { BLOCKS } from "../../subscription-page/constants";
import IntegrationData from "../../../../../../config/integrations.js";
import Loader from "../../../atoms/loader";
import { isValidEmail } from "../../../../utils";
import "./payment.m.css";
import { SubscriptionCouponForm } from "../../../molecules/subscription-coupon-form";

// eslint-disable-next-line react/prop-types
export const Payment = ({ member, planId, activeStep, setActiveStep }) => {
  const subscriptionGroups = useSelector(state =>
    get(state, ["subscriptions"], [])
  );
  const subscriptionData = BLOCKS.filter(item => item.planId == planId)[0];
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("stripe");
  const [couponCode, setCouponCode] = useState("");
  const [isValidCoupon, setIsValidCoupon] = useState(false);
  const [discountedPrice, setDiscountedPrice] = useState(null);
  const [isGift, setIsGift] = useState(false);

  useEffect(() => {
    if (!BLOCKS.filter(item => item.planId == planId || !planId)[0]) {
      window.location.href = "/subscription";
    } else {
      subscriptionGroups &&
        subscriptionGroups.find(item => item.id == subscriptionData.groupId) &&
        setSelectedPlan(
          subscriptionGroups
            .find(item => item.id == subscriptionData.groupId)
            .subscription_plans.find(plan => plan.id == planId)
        );
    }

    if (window.location.href.split("&gift=")[1]) {
      setIsGift(true);
    }
  }, []);

  return (
    <React.Fragment>
      <h1>Confirm details</h1>
      <div styleName="wrapper">
        <PlanDetails
          subscriptionData={subscriptionData}
          selectedPlan={selectedPlan}
          isValidCoupon={isValidCoupon}
          setIsValidCoupon={setIsValidCoupon}
          couponCode={couponCode}
          setCouponCode={setCouponCode}
          discountedPrice={discountedPrice}
          setDiscountedPrice={setDiscountedPrice}
        />
        <PaymentMethod
          planId={planId}
          paymentOption={selectedPaymentOption}
          setPaymentOption={setSelectedPaymentOption}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          member={member}
          isValidCoupon={isValidCoupon}
          couponCode={couponCode}
          discountedPrice={discountedPrice}
          isGift={isGift}
        />
      </div>
    </React.Fragment>
  );
};

const PlanDetails = props => {
  // validate coupon code

  return (
    <div styleName="plan-details-wrapper">
      {/* <img src={data.img} width="40%"/> */}
      <h2>{props.subscriptionData.groupName}</h2>

      <p>
        <span />
      </p>

      <SubscriptionCouponForm {...props} />

      <p>
        <span />
      </p>
      <ul styleName="benefits">
        {BLOCKS[0].benefits.map((benefit, index) => {
          return (
            <li key={index}>
              <i className="material-icons">check</i>
              {benefit}
            </li>
          );
        })}

        {props.subscriptionData.plus &&
          props.subscriptionData.plus.map((benefit, index) => {
            return (
              <li key={index}>
                <i className="material-icons">check</i>
                {benefit}
              </li>
            );
          })}
      </ul>
      <p>
        <span />
      </p>

      {!props.discountedPrice ? (
        <small>
          To pay: <b>₹{props.subscriptionData.price}</b>
        </small>
      ) : (
        <small>
          To pay: <strike>₹{props.subscriptionData.price}</strike>{" "}
          <b>₹{props.discountedPrice / 100}</b>
        </small>
      )}
      <div></div>
    </div>
  );
};

const PaymentMethod = props => {
  const [error] = React.useState(null);
  const [receipentEmail, setReceipentEmail] = useState();

  const handleChange = option => {
    props.setPaymentOption(option);
  };

  return (
    <div styleName="payment-methods-wrapper" className="container">
      {props.isGift && (
        <input
          type="email"
          value={receipentEmail}
          onChange={e => setReceipentEmail(e.target.value)}
          placeholder="Email adress of giftee"
        />
      )}

      <div onClick={() => handleChange("stripe")} styleName="method">
        <input type="radio" checked={props.paymentOption === "stripe"} />
        <label>Credit/Debit Card</label>
        <div styleName="label-img-wrapper">
          <img
            alt="paytm"
            style={{
              height: "2.5rem",
              marginBottom: "-0.4em"
            }}
            styleName="radio-label-img"
            src="https://img.icons8.com/fluency/144/000000/visa.png"
          />
          <img
            alt="paytm"
            style={{
              height: "2.5rem",
              marginBottom: "-0.4em"
            }}
            styleName="radio-label-img"
            src="https://img.icons8.com/color/240/000000/mastercard.png"
          />
        </div>
      </div>

      {!props.isGift && (
        <div onClick={() => handleChange("upi")} styleName="method">
          <input type="radio" checked={props.paymentOption === "upi"} />
          <label>UPI</label>

          <div styleName="label-img-wrapper">
            <img
              alt="paytm"
              style={{
                height: "3rem",
                marginBottom: "-0.45rem"
              }}
              styleName="radio-label-img"
              src="https://images.assettype.com/newslaundry/2022-04/aef00c00-c403-470e-918b-72426b5efdf7/upi__1_.png"
            />
            <img
              alt="paytm"
              style={{
                height: "1.2rem",
                marginBottom: "0.4em"
              }}
              styleName="radio-label-img"
              src="https://thumbor-stg.assettype.com/newslaundry/2021-07/21aac1e9-d2f2-41f5-b6c6-22700fe8a59e/paytmlogo.png"
            />

            <img
              alt="google pay"
              styleName="radio-label-img"
              src="https://images.assettype.com/newslaundry/2020-10/1b086995-83ca-4388-b0ad-88383e02c2da/googlepay.png"
            />

            <img
              alt="phone pe"
              styleName="radio-label-img"
              src="https://images.assettype.com/newslaundry/2020-10/f104aa32-abb5-48d3-84ea-34b7cfcbf20f/phonepe.png"
            />

            {/* <img
                            alt="google pay"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/1b086995-83ca-4388-b0ad-88383e02c2da/googlepay.png"
                        />
                    
                        <img
                            alt="phone pe"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/f104aa32-abb5-48d3-84ea-34b7cfcbf20f/phonepe.png"
                        />
                        <img
                            alt="paytm"
                            style={{
                                height: "2.5rem",
                                marginBottom: "-0.4em"
                            }}
                            styleName="radio-label-img"
                            src="https://img.icons8.com/color/96/000000/paypal.png"
                        /> */}
          </div>
        </div>
      )}

      <div onClick={() => handleChange("razorpay")} styleName="method">
        <input type="radio" checked={props.paymentOption === "razorpay"} />
        <label>{props.isGift && "UPI, "}Wallets, Netbanking, Rupay</label>

        <div styleName="label-img-wrapper">
          <img
            alt="netbanking"
            style={{
              height: "4rem",
              marginTop: "-0.6em",
              marginBottom: "-1em"
            }}
            styleName="radio-label-img"
            src="https://static.thenounproject.com/png/634436-200.png"
          />
          <img
            alt="RuPay"
            style={{
              height: "2.4rem",
              marginBottom: "-0.4em"
            }}
            styleName="radio-label-img"
            src="https://images.assettype.com/newslaundry/2020-10/2e01405e-03c2-4ce4-818c-99461a20c0e0/Rupay_Logo.png"
          />
        </div>
      </div>

      <div onClick={() => handleChange("paypal")} styleName="method">
        <input type="radio" checked={props.paymentOption === "paypal"} />
        <label>Paypal</label>
        <div styleName="label-img-wrapper">
          <img
            alt="paytm"
            style={{
              height: "2.5rem",
              marginBottom: "-0.4em"
            }}
            styleName="radio-label-img"
            src="https://img.icons8.com/color/96/000000/paypal.png"
          />
        </div>
      </div>
      {props.paymentOption === "paypal" ? (
        <p>
          Only for subscribers based outside India. You will be charged in USD.
          You can turn off the auto-renewal from the subscriber dashboard
          anytime.
        </p>
      ) : props.paymentOption === "stripe" ||
        (props.paymentOption === "upi" && !props.isGift) ? (
        <p>
          Your subscription will be renewed automatically, if your bank supports
          it. You can turn off the auto-renewal from the subscriber dashboard
          anytime
        </p>
      ) : null}

      {error && <small>{error}</small>}
      <Subscribe
        {...props}
        receipentEmail={receipentEmail}
        setReceipentEmail={setReceipentEmail}
      />
    </div>
  );
};

const Subscribe = props => {
  const allSubscriptions = useSelector(state =>
    get(state, ["subscriptions"], [])
  );
  const data = BLOCKS.filter(item => item.planId == props.planId)[0];
  const groupDetails =
    allSubscriptions &&
    data &&
    allSubscriptions.find(item => item.id === data.groupId);

  const planDetails =
    groupDetails &&
    groupDetails.subscription_plans &&
    groupDetails.subscription_plans.find(plan => plan.id === data.planId);

  const splitDescription =
    (planDetails &&
      planDetails.description &&
      planDetails.description.split(",")) ||
    "";

  // function to get USD planDetails for paypal payment method
  const getUsdPlan =
    groupDetails &&
    groupDetails.subscription_plans.find(
      plan => plan.id === +splitDescription[1]
    );

  // function to select Equivalent One time plan for razorpay
  const selectEquivalentOneTimePlan = () => {
    const splitDescription =
      (planDetails.description && planDetails.description.split(",")) || "";

    const getSelectedPlan = groupDetails.subscription_plans.filter(
      plan => plan.id === +splitDescription[0]
    );
    if (props.isValidCoupon) {
      getSelectedPlan[0].price_cents = props.discountedPrice;
    }
    return getSelectedPlan[0];
  };

  const redirectURL = global.location;
  const appendSuccessURL =
    planDetails &&
    `&status=success` +
      ((planDetails.duration_unit === "years" &&
        planDetails.subscription_group_id === 113) ||
      planDetails.subscription_group_id === 760 ||
      planDetails.subscription_group_id === 804 ||
      planDetails.subscription_group_id === 805
        ? "&gamechanger=true"
        : planDetails.id === 340
        ? "&disruptor=true"
        : "");
  const successUrl = redirectURL + appendSuccessURL;

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handlePayment = async (
    initAccessType,
    initRazorPayPayment,
    initStripePayment,
    initPaypalPayment,
    validateCoupon
  ) => {
    initAccessType();

    if (!isValidEmail(props.receipentEmail) && props.isGift) {
      setError("Invalid Email");
      return false;
    }

    /* If not active subscriber then Proceed with subscription payment */
    if (props) {
      setLoading(true);
      /*
                Initiate razorpay 
            */
      if (props.paymentOption === "razorpay") {
        const options = {
          argType: "options",
          selectedPlan: selectEquivalentOneTimePlan(),
          planType: "standard",
          couponCode: props.isValidCoupon ? props.couponCode : "",
          successUrl: successUrl,
          recipientSubscriber: {
            recipient_identity_provider: "email",
            recipient_identity: props.receipentEmail
          }
        };

        initRazorPayPayment(options)
          .then(async res => {
            // TODO need to store this invoice responce in store for my account
            res && (await handlePaymentSuccess(res, successUrl));
          })
          .catch(error => {
            setLoading(false);
            const getErrorMessage = get(
              error,
              ["error", "message", "subscriber", 0],
              ""
            );
            console.error(`Razorpay error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
          });
      }

      if (props.paymentOption === "upi") {
        const options = {
          argType: "options",
          selectedPlan: planDetails,
          planType: "standard",
          couponCode: props.isValidCoupon ? props.couponCode : "",
          successUrl: successUrl,
          recipientSubscriber: {
            recipient_identity_provider: "email",
            recipient_identity: props.receipentEmail
          }
        };

        initRazorPayPayment(options)
          .then(async res => {
            // TODO need to store this invoice responce in store for my account
            res && (await handlePaymentSuccess(res, successUrl));
          })
          .catch(error => {
            setLoading(false);
            const getErrorMessage = get(
              error,
              ["error", "message", "subscriber", 0],
              ""
            );
            console.error(`Razorpay error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
          });
      }

      /*
                Initiate stripe 
            */
      if (props.paymentOption === "stripe") {
        const options = {
          argType: "options",
          selectedPlan:
            props.isGift || props.isValidCoupon
              ? selectEquivalentOneTimePlan()
              : planDetails,
          planType: "standard",
          couponCode: props.isValidCoupon ? props.couponCode : "",
          successUrl: successUrl,
          cancelUrl: redirectURL.toString(),
          recipientSubscriber: {
            recipient_identity_provider: "email",
            recipient_identity: props.receipentEmail
          }
        };

        initStripePayment(options)
          .then(async res => {
            // TODO need to store this invoice responce in store for my account
            res && (await handlePaymentSuccess(res, successUrl));
          })
          .catch(error => {
            setLoading(false);
            const getErrorMessage = get(
              error,
              ["error", "message", "subscriber", 0],
              ""
            );
            console.error(`Stripe error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
          });
      }

      /*
                Initiate paypal
            */
      if (props.paymentOption === "paypal") {
        let usdPlan = {};

        usdPlan = groupDetails.subscription_plans.find(
          plan => plan.id == splitDescription[1]
        );

        if (props.isValidCoupon) {
          await validateCoupon(usdPlan.id, props.couponCode)
            .then(res => {
              if (res.valid) {
                usdPlan.price_cents = props.discountedPrice;
              }
            })
            .catch(err => console.error(`Paypal coupon error: ${err}`));
        }

        const options = {
          argType: "options",
          selectedPlan:
            props.isGift || props.isValidCoupon ? usdPlan : getUsdPlan,
          planType: "standard",
          couponCode: props.isValidCoupon ? props.couponCode : "",
          recipientSubscriber: {
            recipient_identity_provider: "email",
            recipient_identity: props.receipentEmail
          },
          returnUrl: successUrl,
          cancelUrl: "https://newslaundry.com"
        };

        initPaypalPayment(options)
          .then(async res => {
            // TODO need to store this invoice responce in store for my account
            res && (await handlePaymentSuccess(res, successUrl));
          })
          .catch(error => {
            setLoading(false);
            const getErrorMessage = get(
              error,
              ["error", "message", "subscriber", 0],
              ""
            );
            console.error(`Razorpay error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
          });
      }
    }
  };

  const handlePaymentSuccess = async (res, successUrl) => {
    setLoading(false);
    console.log("success");
    window.location.href = successUrl;
  };

  /*
    Accesstype component prop values
  */
  const integrationsConfig = IntegrationData();
  const pub = useSelector(state => get(state, ["qt", "config", "publisher"]));
  const email = get(props.member, ["email"], "");
  const phone = get(props.member, ["metadata", "phone"], "");
  const isStaging = get(pub, ["publisher", "accessTypeEnvironment"], true);
  const enableAccesstype = get(
    pub,
    ["publisher", "publisher", "enableAccesstype"],
    true
  );
  const accessTypeKey = isStaging
    ? integrationsConfig.stagingAccessTypeKey
    : integrationsConfig.accessTypeKey;
  const accessTypeBkIntegrationId = isStaging
    ? integrationsConfig.stagingAccessTypeBkIntegrationId
    : integrationsConfig.accessTypeBkIntegrationId;

  return (
    <div styleName="subscribe-wrapper">
      <AccessType
        enableAccesstype={enableAccesstype}
        isAccessTypeCampaignEnabled={true}
        isStaging={false}
        accessTypeKey={accessTypeKey}
        accessTypeBkIntegrationId={accessTypeBkIntegrationId}
        email={props.receipentEmail || email}
        phone={phone}
      >
        {({
          initAccessType,
          initRazorPayPayment,
          initStripePayment,
          initPaypalPayment,
          validateCoupon
        }) => {
          return (
            <React.Fragment>
              {loading ? (
                <button>
                  <Loader color="white" />
                </button>
              ) : (
                <button
                  onClick={() =>
                    handlePayment(
                      initAccessType,
                      initRazorPayPayment,
                      initStripePayment,
                      initPaypalPayment,
                      validateCoupon
                    )
                  }
                >
                  Subscribe
                  <br />
                  {!props.discountedPrice ? (
                    <small>
                      ₹{data && data.price} {data && data.name}
                    </small>
                  ) : (
                    <small>
                      <strike>₹{data && data.price} </strike>₹
                      {props.discountedPrice / 100} {data && data.name}{" "}
                    </small>
                  )}
                </button>
              )}
              <p>{error}</p>
            </React.Fragment>
          );
        }}
      </AccessType>
    </div>
  );
};
